"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bubbles = void 0;
const bubble_1 = require("./bubble");
class Bubbles {
    constructor(props) {
        this.props = props;
    }
    static createEmpty(tenantId) {
        return new Bubbles({ tenantId, bubbles: [] });
    }
    static fromProps(props) {
        return new Bubbles(props);
    }
    toProps() {
        return this.props;
    }
    get id() {
        return `${this.tenantId}-bubbles`;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get names() {
        return new Set(this.bubbles.map((bubble) => bubble.name));
    }
    get namesSorted() {
        return [...this.names].sort();
    }
    get bubbles() {
        return [
            ...this.props.bubbles.map((props) => bubble_1.Bubble.fromProps(props)),
        ].sort((a, b) => a.name.localeCompare(b.name));
    }
    get isEmpty() {
        return this.bubbles.length === 0;
    }
    withBubbleAdded(bubble) {
        if (!this.mayAddBubble(bubble)) {
            return this;
        }
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: [...this.toProps().bubbles, bubble.toProps()],
        });
    }
    withBubbleRemoved(name) {
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: this.toProps().bubbles.filter((c) => c.name !== name),
        });
    }
    withChangedMaxChildrenForBubble(name, newCapacity) {
        const bubble = this.findBubbleByName(name);
        if (!bubble) {
            return this;
        }
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: [
                ...this.toProps().bubbles.filter((c) => c.name !== name),
                bubble.withMaxChildren(newCapacity).toProps(),
            ],
        });
    }
    withRenamedBubble(oldName, newName) {
        const currentBubble = this.findBubbleByName(oldName);
        if (this.bubbleWithNameExists(newName) || currentBubble == null) {
            return this;
        }
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: [
                ...this.toProps().bubbles.filter((c) => c.name !== oldName),
                currentBubble.withName(newName).toProps(),
            ],
        });
    }
    withChildAddedToBubble(bubbleName, weekIdentifier, childId) {
        const bubble = this.findBubbleByName(bubbleName);
        if (bubble == null) {
            return this;
        }
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: [
                ...this.toProps().bubbles.filter((c) => c.name !== bubbleName),
                bubble.withChildAdded(weekIdentifier, childId).toProps(),
            ],
        });
    }
    withChildRemovedFromBubble(bubbleName, weekIdentifier, childId) {
        const bubble = this.findBubbleByName(bubbleName);
        if (bubble == null) {
            return this;
        }
        return Bubbles.fromProps({
            ...this.toProps(),
            bubbles: [
                ...this.toProps().bubbles.filter((c) => c.name !== bubbleName),
                bubble.withChildRemoved(weekIdentifier, childId).toProps(),
            ],
        });
    }
    findBubbleByName(name) {
        var _a;
        return (_a = this.bubbles.find((bubble) => bubble.name === name)) !== null && _a !== void 0 ? _a : null;
    }
    findBubbleChildIsAssignedTo(weekIdentifier, childId) {
        var _a;
        return ((_a = this.bubbles.find((bubble) => bubble.includesChild(weekIdentifier, childId))) !== null && _a !== void 0 ? _a : null);
    }
    childIsAssignedABubble(weekIdentifier, childId) {
        return this.findBubbleChildIsAssignedTo(weekIdentifier, childId) != null;
    }
    mayAddBubble(bubble) {
        return !this.bubbleWithNameExists(bubble.name);
    }
    bubbleWithNameExists(name) {
        return this.findBubbleByName(name) != null;
    }
    assignmentsForChild(childId) {
        return this.bubbles.reduce((acc, bubble) => [
            ...acc,
            ...bubble.weeksForChild(childId).map((weekIdentifier) => {
                return {
                    weekIdentifier,
                    bubbleName: bubble.name,
                };
            }),
        ], []);
    }
    /** Returns all children (represented by their id) already assigned to a bubble */
    allChildIdsAssignedToABubble(weekIdentifier) {
        return this.bubbles.reduce((set, bubble) => {
            return new Set([
                ...bubble.childIdsInBubble(weekIdentifier),
                ...set.values(),
            ]);
        }, new Set());
    }
}
exports.Bubbles = Bubbles;
//# sourceMappingURL=bubbles.js.map